<template>
  <transition :name="transName('zoom-in')">
    <div class="base-modal">
      <div class="base-modal-con">
        <div class="base-modal-wrapper">
          <img :src="currentIconUrl" class="icon-base-modal" />
          <p class="base-modal-text" v-if="text">
            {{ text }}
          </p>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import iconSuccess from 'assets/images/common/icon-notification-success.png';

export default {
  name: 'base-modal',
  mounted() {},
  data() {
    return {
      resources: {
        SUCCESS: iconSuccess,
      },
    };
  },
  props: {
    text: {
      type: String,
      default: '',
    },
    iconUrl: {
      type: String,
      default: '',
    },
    type: {
      type: String,
      default: 'SUCCESS',
    },
  },
  computed: {
    // 优先取配置的图标 其次传入的图标 默认成功图标
    currentIconUrl() {
      return this.resources[this.type] || this.iconUrl || this.resources.SUCCESS;
    },
  },
  components: {},
};
</script>
<style lang="scss" scoped>
@import '~assets/css/variable.scss';

.base-modal {
  .base-modal-con {
    position: fixed;
    z-index: 999;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    .base-modal-wrapper {
      position: absolute;
      display: flex;
      flex-flow: column;
      align-items: center;
      justify-content: center;
      width: px(180);
      height: px(180);
      top: 50%;
      left: 50%;
      transform: translate(-50%, -150%);
      opacity: 0.6;
      background: #000000;
      border-radius: px(24);
      .icon-base-modal {
        width: px(76);
        height: px(76);
      }
      .base-modal-text {
        padding-top: px(18);
        font-size: px(30);
        color: #ffffff;
        text-align: center;
        line-height: px(30);
      }
    }
  }
}
</style>
